export const MIME_TYPES_ACCEPTED_BY_API = {
  'application/pdf': 'pdf',
  'application/xml': 'xml',
  'application/zip': 'zip',
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/gif': 'gif',
  'image/tiff': 'tiff',
  'image/webp': 'webp',
  'text/csv': 'csv',
  'text/plain': 'csv', // NOTE: See RADAR-7787 for why we allow `text/plain` uploads here.
  'text/tab-separated-values': 'tsv',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'docx',
  'application/vnd.android.package-archive': 'apk',
  'application/x-pem-file': 'pem',
  'application/x-x509-ca-cert': 'pem',
  'application/x-x509-client-cert': 'pem',
  'application/x-zip-compressed': 'zip',
} as const;

export const DEFAULT_MIME_TYPES = {
  'application/pdf': 'pdf',
  'application/xml': 'xml',
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/webp': 'webp',
  'text/csv': 'csv',
  'text/plain': 'csv',
  'text/tab-separated-values': 'tsv',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'docx',
} as const;
export type MimeType = keyof typeof MIME_TYPES_ACCEPTED_BY_API;
